import { store } from '@/pinia/store'
import { isApp } from '@/utils'
import { currentDev } from '@/config/env'
import { EVENT_MAP, sendLogToUWeb } from '@/plugins/umeng.ts'

// 埋点
export const useTrackingPoint = (
  eventName: string, // 事件名称
  module: string, // 模块名称
  action: string, // 页面行为 enter：进入 leave：离开
  action_id: string, // 动作id
  origin: string, // 来源
  enterTime: string | number, // 进入时间
  leaveTime: string | number, // 离开时间
  stay_duration: string | number, // 停留时长
  ext?: any,
) => {
  const storeData = store()
  const sendData = {
    module: module || '空',
    action: action || '空',
    action_id: action_id || '空',
    user_id: storeData.appData.userId || '空',
    device_id: isApp() ? storeData.headerInfo['c-id'] || '空' : '空',
    origin: origin || '空',
    enterTime: enterTime || '空',
    leaveTime: leaveTime || '空',
    stay_duration: stay_duration || '空',
    os: 'H5',
    ext: {
      ...ext,
      status: storeData.appData.userId !== '' ? '1' : '0',
    },
  }
  if (currentDev !== 1) {
    const toastData = {
      eventId: eventName,
      ...sendData,
    }
    console.log(`260915上报埋点数据-${action}：` + JSON.stringify(toastData))
  }
  sendLogToUWeb(
    EVENT_MAP.BUSINESS_EVENT,
    eventName,
    JSON.stringify({
      ...sendData,
    }),
  )
}
